module.exports = __webpack_public_path__ + "static/media/1.55feef4d.jpg";